import { Box, Button } from "@chakra-ui/react";
import { useState } from "react";
import { isEmail } from "validator";
import { FormField } from "../../../components/FormField/FormField";
import { FormInput } from "../../../components/FormInput/FormInput";
import { SheetHeader } from "../../../components/SheetHeader/SheetHeader";

interface EmailStepProps {
  defaultEmail?: string;
  onSubmit: (email: string) => Promise<void>;
}

export const EmailStep = ({
  defaultEmail = "",
  onSubmit,
}: EmailStepProps) => {
  const [email, setEmail] = useState(defaultEmail);
  const [error, setError] = useState("");

  const submit = async () => {
    if (!email) {
      setError("Please enter your email");
      return;
    }
    if (!isEmail(email)) {
      setError("Please double check your email");
      return;
    }
    setError("");
    await onSubmit(email);
  };

  return (
    <Box
      as="form"
      display="flex"
      flexDirection="column"
      gap="16px"
      onSubmit={(e: React.FormEvent) => {
        e.preventDefault();
        submit();
      }}
    >
      <SheetHeader
        title="What's your email?"
        subtitle="We'll send a 6-digit code to verify it."
        pb="0"
      />
      <Box px="20px" display="flex" flexDirection="column" gap="16px">
        <FormField error={error}>
          <FormInput
            type="email"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            placeholder="you@example.com"
            autoFocus
          />
        </FormField>
        <Button type="submit" size="2xl" w="100%">
          Continue
        </Button>
      </Box>
    </Box>
  );
};
